import http from 'plugins/axios';

export default {
    getProcessorList(data) {
        return http.get({
            url: '/admin/processor/list',
            data
        });
    },
    updatePendingHeight({ coinType, height, processorId }) {
        return http.post({
            url: '/admin/processor/update/pending',
            data: {
                coinType,
                processorId,
                height
            },
            dataType: 'form'
        });
    },
    updateConfimedHeight({ coinType, height, processorId }) {
        return http.post({
            url: '/admin/processor/update/confirmed',
            data: {
                coinType,
                processorId,
                height
            },
            dataType: 'form'
        });
    },
    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
};